import type { FaireProductEntity } from "../../entity_types/product";

export const p_jvzkgxjn8e: FaireProductEntity = {
  token: "p_jvzkgxjn8e",
  type: "product",
  name: "Millennial Gaia Statue",
  brandToken: "b_23nx3nnsvm",
  brandName: "Pacific Trading",
  imageUrl:
    "https://cdn.faire.com/fastly/3a9e9f687193d89d6024c292f341eb58190691affdb768a48b39a31bf7a1d776.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b5c9995dd382ec94fe4b2827a2562343faa8924b39be5c86d6e215deb8aabac9.jpeg",
  ],
  priceDollars: 16.63,
  description:
    'Millennial Gaia Statue\nProduct Size: 3.25" X 2.75" X 4.25"\nMaterial: Cold Cast Resin\nCase Pack: 36\nBy Oberon Zell',
  tags: [],
  msrpDollars: 44.33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:43.315Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
